import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/fonts.css';

ReactDOM.render(<App />, document.getElementById('root'));
